import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Map } from './map';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'map-editor',
  styleUrls: ['./map-editor.component.scss'],
  templateUrl: './map-editor.component.pug'
})
export class MapEditorComponent implements OnInit {
  public maps: Map[] = [];
  public mapCreationMode: boolean = false;
  public localState: any;
  public screenshotControl: string = '';
  public maxXControl: string = '';
  public minXControl: string = '';
  public maxYControl: string = '';
  public minYControl: string = '';
  public pathControl: string = '';
  public nameControl: string = '';
  public configControl: string = '';
  public descriptionControl: string = '';
  private standardWidth: number = 300;
  constructor(
    public route: ActivatedRoute,
    private http: HttpClient
  ) { }
  public ngOnInit() {

    this.http.get(remoteApiHost + 'getMaps').subscribe((data: any) => {
      this.maps = [];
      for (let i of data) {
        let map = new Map(this.http);
        map.Updated = i.Updated;
        map.Created = i.Created;
        map.Bbox = i.Bbox;
        map.Screenshot = i.Screenshot;
        map.Path = i.Path;
        map.MapId = i._id;
        map.Name = i.Name;
        map.Config = i.Config;
        map.Description = i.Description;
        this.maps.push(map);
      }
      // this.maps = data;
    });
    // this.http.post('http://localhost:3000/api/admin/creatMap', {}).subscribe((data: any) => {

    // });
  }
  public async getBase64(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/png, image/jpeg';
      let click = new MouseEvent('click');
      input.dispatchEvent(click);
      input.onchange = (e: any) => {
        if (e.path.length) {
          if (e.path[0].files.length) {
            let file = e.path[0].files[0];
            const reader = new FileReader();
            reader.onload = (f: any) => {
              let base64_image = f.target.result;
              this.image64ToImage(base64_image).then((image) => {
                let prop = image.width / image.height;
                image.width = this.standardWidth;
                image.height = image.width / prop;
                return resolve(this.resizeImage(image, image.width, image.height));
              });
            };
            reader.readAsDataURL(file);
          } else {
            return reject('no file');
          }
        } else {
          return reject('no file');
        }
      };
    });
  }
  public async upload(row?: Map) {
    if (row) {
      row.Screenshot = await this.getBase64();
      return;
    }
    this.screenshotControl = await this.getBase64();
  }

  public deleteMap(row) {
    row.isEdit = false;
    row.http.post(remoteApiHost + 'api/admin/deleteInfo', {
      Created: row.Created,
      Updated: new Date(),
      Bbox: row.Bbox,
      Screenshot: row.Screenshot,
      Path: row.Path,
      MapId: row.MapId,
      Name: row.Name,
      Config: row.Config,
      Description: row.Description
    }).subscribe((data: any) => {
      let currentMap = this.maps.indexOf(row);
      this.maps.splice(currentMap, 1);
    });
  }
  public sendMap() {
    let bbox = [this.minXControl, this.maxXControl, this.minYControl, this.maxYControl]
    this.http.post(remoteApiHost + 'api/admin/createMap', {
      Bbox: bbox,
      Path: this.pathControl,
      Name: this.nameControl,
      Screenshot: this.screenshotControl,
      Config: this.configControl,
      Description: this.descriptionControl
    }).subscribe((data: any) => {
      let newMap = new Map(this.http);
      newMap.Bbox = data.Bbox;
      newMap.Path = data.Path;
      newMap.Name = data.Name;
      newMap.Config = data.Config;
      newMap.Screenshot = data.Screenshot;
      newMap.Created = data.Created;
      newMap.Screenshot = data.Screenshot;
      newMap.Updated = data.Updated;
      newMap.Description = data.Description;
      this.maps = [...this.maps, newMap];
      this.mapCreationMode = false;
    });
  }

  private image64ToImage(base64: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = base64;
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function (err) {
        reject(err);
      };
    });
  }
  private resizeImage(image: HTMLImageElement, newWidth: number, newHeight: number): string {
    const canvas = document.createElement('canvas');
    canvas.width = newWidth;
    canvas.height = newHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, newWidth, newHeight);
    return canvas.toDataURL('image/jpeg');
  }

}

// export interface MapCatalog {
//   Created: Date;
//   Updated: Date;
//   Bbox: [number, number, number, number];
//   screenshot: string;
//   Path: string;
//   Name: string;
//   Config: string;
//   Description: string;
// }



// WEBPACK FOOTER //
// ./src/app/admin/map-editor/map-editor.component.ts